import { useState, useCallback } from "react";
import { Redirect, useLocation, withRouter } from "react-router-dom";
import { useAuthContextV2 } from "../../../auth-state";
import apiClient from "../../../application/apis/tenant-management/tenant-management-client";
import { toast } from "react-toastify";
import { InputWithButton } from "../../molecules/input-with-button";
import { CloudGovApiError } from "../../../application/domain/api-error";
import { reportAsyncError } from "../../../error-reporter";
import {
  isValidRedirect,
  parseQueryOfLocation,
} from "../../../utils/url-utils";
import corporateLogo from "../../../assets/corporate_logo.svg";

export const LoginTOTPPage = withRouter(({ history }) => {
  const { to } = parseQueryOfLocation(useLocation()) as {
    to?: string;
  };
  const authCtx = useAuthContextV2();
  const [errorMessage, setErrorMessage] = useState("");

  if (!sessionStorage.getItem("MFAJWT") || !sessionStorage.getItem("userId")) {
    history.push("/login");
  }

  const handleSubmit = useCallback(
    async (totp: string) => {
      try {
        await apiClient.checkTOTP({
          // TODO: これはLocalStorageにすべき
          MFAJWT: sessionStorage.getItem("MFAJWT")!,
          userId: sessionStorage.getItem("userId")!,
          TOTP: totp,
        });
        await authCtx.syncAuth();
        sessionStorage.clear();
        const decoded = to ? decodeURIComponent(to) : null;
        if (decoded && isValidRedirect(decoded)) {
          // NOTE(adshidtadka): ローカルで別プロダクトにリダイレクトする際はポートを手動で変更しなければならない場合がある
          window.location.assign(decoded);
        } else {
          history.push("/");
        }
      } catch (e) {
        if (CloudGovApiError.isRetryable(e)) {
          setErrorMessage(
            "通信に失敗しました。ネットワーク接続などをご確認の上、再実行してください。",
          );
          return;
        }
        if (CloudGovApiError.isErrorCode(e, "bad_request")) {
          setErrorMessage("認証に失敗しました。");
          return;
        }
        if (
          CloudGovApiError.isErrorCode(
            e,
            "forbidden.not_permitted_network_access",
          )
        ) {
          setErrorMessage(
            "ご利用中のネットワークからのアクセスが許可されていません。",
          );
          return;
        }
        if (CloudGovApiError.isUserJustLoginLocked(e)) {
          toast.error(
            "このアカウントはロックされました。しばらく時間をおいてから再度ログインしていただくか、管理者にロックの解除を依頼してください。",
          );
          history.replace("/");
          return;
        }
        if (CloudGovApiError.isUserLoginLocked(e)) {
          toast.error(
            "このアカウントはロックされています。しばらく時間をおいてから再度ログインしていただくか、管理者にロックの解除を依頼してください。",
          );
          history.replace("/");
          return;
        }
        reportAsyncError(e);
      }
    },
    [authCtx, history, to],
  );

  if (authCtx.auth.isAuthed) {
    const decoded = to ? decodeURIComponent(to) : null;
    if (decoded && isValidRedirect(decoded)) {
      window.location.assign(decoded);
      return null;
    }
    return <Redirect to="/" />;
  }

  return (
    <div className="c-content-wrapper">
      <div
        className="columns is-centered is-vcentered"
        style={{
          marginTop: "auto",
          marginBottom: "auto",
        }}
      >
        <div
          className="column is-4-desktop"
          style={{
            maxWidth: "520px",
          }}
        >
          <div
            className="box"
            style={{
              borderRadius: 0,
              padding: "36px",
            }}
          >
            <p className="has-text-centered">
              <img
                src={corporateLogo}
                alt="株式会社グラファー 会社ロゴ"
                style={{
                  width: "120px",
                }}
              />
            </p>
            {errorMessage !== "" && (
              <div
                className="notification is-danger is-light"
                style={{
                  marginTop: "12px",
                }}
              >
                {errorMessage}
              </div>
            )}
            <h2
              className="has-text-weight-bold"
              style={{
                marginTop: "12px",
              }}
            >
              認証コードを入力して下さい
            </h2>
            <InputWithButton
              onSubmit={handleSubmit}
              type="password"
              btnName="認証"
              placeholder={"認証コード(6桁)"}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
